const staticCache = new Map();
export default staticCache;
